/* ============================================================================
 * nav.js — the single navigation registry, ported from shell.js NAV.
 * Add a top-level page here and it appears in the sidenav everywhere, cap-gated.
 * `key` matches the route's `active` marker; `cap` (comma-allowed) gates it.
 * ========================================================================== */
export const NAV = [
  { href: "/", label: "Home", key: "home", ico: "⌂" },
  { href: "/heatmap", label: "Heatmap", cap: "heatmap.view", key: "heatmap", ico: "▦" },
  { href: "/chart", label: "Chart", cap: "chart.view", key: "chart", ico: "◫" },
  { href: "/alerts", label: "Alerts", cap: "alerts.view", key: "alerts", ico: "◔" },
  { href: "/multi-alerts", label: "Multi-alerts", cap: "multi_alerts.view", key: "multi-alerts", ico: "◍" },
  { href: "/notifications", label: "Templates", cap: "templates.view", key: "templates", ico: "✎" },
  { href: "/trading", label: "Trading", cap: "trading.view", key: "trading", ico: "↗" },
  { href: "/ma-trading", label: "MA-Trading", cap: "ma_trading.view", key: "ma-trading", ico: "⇗" },
  { href: "/ma-trading/positions", label: "MA-Positions", cap: "ma_trading.view", key: "ma-positions", ico: "◇" },
  { href: "/positions", label: "Positions", cap: "trading.view", key: "positions", ico: "◆" },
  { href: "/copy-trading", label: "Copy Trade", cap: "copy_trading.view", key: "copy-trading", ico: "⧉" },
  { href: "/copy-trade-alerts", label: "Copy Alerts", cap: "copy_trading.view", key: "copy-trade-alerts", ico: "🔔" },
  { href: "/scalping", label: "Scalping", cap: "scalping.view", key: "scalping", ico: "⚡" },
  { href: "/scalping/positions", label: "Scalp Positions", cap: "scalping.view", key: "scalp-positions", ico: "◈" },
  { href: "/settings/telegram", label: "Telegram", cap: "telegram.view", key: "telegram", ico: "✉" },
  { href: "/settings/keys", label: "API Keys", cap: "keys.view", key: "keys", ico: "⚿" },
  { href: "/docs", label: "Docs", cap: "docs.view", key: "docs", ico: "☰" },
  { href: "/users", label: "Users", cap: "users.view", key: "users", ico: "◉" },
  { href: "/admin", label: "Admin", cap: "users.manage", key: "admin", ico: "⚙" },
  { href: "/obsidian", label: "Obsidian", cap: "users.manage", key: "obsidian", ico: "⌘" },
];

/** Does the caller's cap set satisfy a (possibly comma-joined) cap spec? */
export function hasCap(caps, spec) {
  if (!spec) return true;
  const need = String(spec).split(",").filter(Boolean);
  return need.length === 0 || need.some((c) => caps.has(c));
}
